import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=43f36903&scoped=true&lang=pug"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "./platform.vue?vue&type=style&index=0&id=43f36903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f36903",
  null
  
)

export default component.exports